import React, { useState, useEffect } from "react";
import OtsCloseEventCard from "./OtsCloseEventCard/OtsCloseEventCard";
import { getClosedEvents } from "../../services/otsEventService";
import { useAuthentication } from "meportal/AuthenticationProvider";
import { OtsAircraft } from "../../Models/OtsAircraft";
import { ClosedSearchParams, ClosedSortingParams } from "../../Models/ClosedSearchParams";
import { useSelector } from "react-redux";
import { convertClosedSearchParamsForApiCall } from "../../helpers/Util";

interface PrevData {
  [index: number]: any;
}

interface ShowClosedEventsProps {
    aircraftdata: OtsAircraft[];
    cardClick: Function;
    continousToken: string;
    datalevel: any;
    resetPage: boolean;
    setResetToFalse: any;
}


export default function ShowClosedEvents(props: ShowClosedEventsProps) {
    const { userData, getLatestAccessToken } = useAuthentication();
    const { aircraftdata, cardClick, datalevel } = props;
    const [aircrafts, setAircrafts] = useState<OtsAircraft[]>([]);
    const [totalpages, setTotalPage] = useState(1);
    const [number, setNumber] = useState(1);
    const [continousToken, setContinousToken] = useState("");
    const [prevData, setPrevData] = useState<PrevData>({});
    const closedSearchParams:ClosedSearchParams = useSelector((state: any) => state.closedFilterSort.filters);
    const sortParams:ClosedSortingParams = useSelector((state: any) => state.closedFilterSort.sorting);

    useEffect(() => {
        if (props.resetPage) {
            setNumber(1);
            setTotalPage(1);
            setPrevData({});
            setPrevData({
                [1]: aircraftdata
            });
            setContinousToken(props.continousToken);
        }
        setAircrafts(aircraftdata);
    }, [aircraftdata]);


    const handlePrevButtonClick = () => {
        if (number > 1) {
            datalevel(prevData[number - 1]);
            setNumber(number - 1);
            instantScrollToTop(); // Scroll to top when previous button is clicked
        }
    }

    const handleNextButtonClick = () => {
        console.log('Show Closed Events\nPage Number:', number, '\nTotal Pages:', totalpages, '\n Aircraft Registration:', props.aircraftRegistration);
        if (prevData[number + 1] != null) {
            datalevel(prevData[number + 1]);
            setNumber(number + 1);
        }
        else {
            if (continousToken) {
              getLatestAccessToken().then((token) => { 
                userData.access_token = token;
                let updatedSearchParams = convertClosedSearchParamsForApiCall(closedSearchParams);
                getClosedEvents(userData, updatedSearchParams, sortParams, continousToken).then(
                    (data) => {
                      if(!data){
                        setContinousToken("");
                      }
                      else{
                        setContinousToken(data.continousToken);
                        props.setResetToFalse();
                        datalevel(data.outOfServiceRecoveryResponse);
                        setTotalPage(number + 1 > totalpages ? number + 1 : totalpages);
                        setNumber(number + 1);
                        setPrevData(prevState => ({
                            ...prevState,
                            [number + 1]: data.outOfServiceRecoveryResponse
                        }));
                      }
                    },
                    (error) => {
                      
                    }
                );
              });
            }
        }
        instantScrollToTop();  // Scroll to top when next button is clicked
    }

    const instantScrollToTop = () => {
        const container = document.querySelector('.closed-dashboard-container.drawer-open .card_containers');
        if (container) {
            container.scrollTop = 0;
        } else {
            window.scrollTo({ top: 0, behavior: 'auto' });
        }
    };

    const SvgNumber = () => {
        return (
          <svg
            className="page"
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="#0074C8"
          >
            <circle cx="16" cy="16" r="15.5" stroke="#0074C8" />
            <text
              className="page-number"
              x="15"
              y="21"
              textAnchor="middle"
              fontSize="16"
              fill="#FFFFFF"
            >
              {number}
            </text>
          </svg>
        );
      };
      
      const ArrowClosedPrevious = () => {
        const [isHoveredClosedPrev, setIsHoveredClosedPrev] = React.useState(false);
        const [isClosedPrevActive, setIsClosedPrevActive] = React.useState(false);
      
        const handleClosedPrevMouseEnter = () => {
          setIsHoveredClosedPrev(true);
          setIsClosedPrevActive(true);
        };
      
        const handleClosedPrevMouseLeave = () => {
          setIsHoveredClosedPrev(false);
          setIsClosedPrevActive(false);
        };
      
        const circlefill=()=>{
            if(isHoveredClosedPrev){
                return "#ebeef1"
            }
            else{
                if(isClosedPrevActive){
                    return "#ebeef1"
                }
                else{
                    return "white"
                }
            }
        }

        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            onMouseEnter={handleClosedPrevMouseEnter}
            onMouseLeave={handleClosedPrevMouseLeave}
          >
            <circle
              cx="16"
              cy="16"
              r="16"
              fill={circlefill()}
            />
            <circle
              cx="16"
              cy="16"
              r="15.5"
              stroke="#0074CB"
              strokeOpacity= "0.65"
            />
            <svg x="8" y="8" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.3938 6.34627L14.4779 6.41889C14.7442 6.68516 14.7684 7.10182 14.5505 7.39543L14.4779 7.47955L10.0086 11.9492L14.4779 16.4189C14.7442 16.6852 14.7684 17.1018 14.5505 17.3954L14.4779 17.4795C14.2116 17.7458 13.795 17.77 13.5014 17.5522L13.4172 17.4795L8.59367 12.6563C8.20315 12.2658 8.20315 11.6326 8.59367 11
                    .2421L13.4172.6.41889C13.6835.15262.1002.12842.3938.34627Z"
                fill="#0074CB"
              />
            </svg>
          </svg>
        );
      };
      
      const ArrowClosedNext = () => {
        const [isHoveredClosedNext, setIsHoveredClosedNext] = React.useState(false);
        const [isClosedNextActive, setIsClosedNextActive] = React.useState(false);

        const handleClosedNextMouseEnter = () => {
          setIsHoveredClosedNext(true);
          setIsClosedNextActive(true);
        };

        const handleClosedNextMouseLeave = () => {
          setIsHoveredClosedNext(false);
          setIsClosedNextActive(false);
        };

        const nextcirclefill=()=>{
            if(isHoveredClosedNext){
                return "#ebeef1"
            }
            else{
                if(isClosedNextActive){
                    return "#ebeef1"
                }
                else{
                    return "white"
                }
            }
        }
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            onMouseEnter={handleClosedNextMouseEnter}
            onMouseLeave={handleClosedNextMouseLeave}
          >
            <circle cx="16" cy="16" r="16" fill={nextcirclefill()}/>
            <circle cx="16" cy="16" r="15.5" stroke="#0074CB" strokeOpacity="0.65" />
            <svg x="8" y="8" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.60457 17.5522L9.52045 17.4795C9.25418 17.2133 9.22998 16.7966 9.44783 16.503L9.52045 16.4189L13.9898 11.9492L9.52045 7.47955C9.25418 7.21328 9.22998 6.79662 9.44783 6.50301L9.52045 6.41889C9.78672 6.15262 10.2034 6.12842 10.497 6.34627L10.5811 6.41889L15.4047 11.2421C15.7952 11.6326 15.7952 12.2658 15.4047 12.6563L10.5811 17.4795C10.3148 17.7458 9.89818 17.77 9.60457 17.5522Z"
                fill="#0074CB"
              />
            </svg>
          </svg>
        );
      };

    return (
        <div className="containers">
            <div className="card_containers">
                {aircrafts.map((aircraft: any, index: number) => {
                    return (
                        <div key={aircraft.id} className="data-card-closed-event">
                            <OtsCloseEventCard
                                otsCloseEvent={aircraft}
                                onCardClick={() => cardClick(aircraft)}
                            />
                        </div>
                    )
                })}
            </div>
            <footer className="closed-footer">
                <div className={aircrafts.length == 0 ? "hide_pagination" : "pagination_block"}>

                        <div onClick={handlePrevButtonClick} className={number == 1 ? "disabled page-arrow" : "page-arrow-left"} role="button" tabIndex={0}
                        onKeyDown={(e) => {
                          if(e.key === ' '){
                            handlePrevButtonClick();
                          }}}>
                       <ArrowClosedPrevious/>
                       </div>
                    <SvgNumber />
                    <div className={(!continousToken && number == totalpages) ? "disabled page-arrow" : "page-arrow-right"} onClick={handleNextButtonClick} role="button" tabIndex={0}
                    onKeyDown={(e) => {
                      if(e.key === ' '){
                        handleNextButtonClick();
                      }}}>
                        <ArrowClosedNext/>
                    </div>
                </div>
            </footer>
        </div>
    )
}